import { render, staticRenderFns } from "./QuestionAboutWhite.vue?vue&type=template&id=04338b07&scoped=true"
import script from "./QuestionAboutWhite.vue?vue&type=script&lang=ts"
export * from "./QuestionAboutWhite.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./QuestionAboutWhite.vue?vue&type=style&index=0&id=04338b07&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./QuestionAboutWhite.vue?vue&type=style&index=1&id=04338b07&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "04338b07",
  null
  ,true
)

export default component.exports